import type { Actor } from '@/types';

export const actorList: Actor[] = [
  {
    id: 'a01',
    name: '苏晚棠',
    photo: 'https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20of%20a%20young%20Chinese%20actress%20in%20a%20soft%20gold%20silk%20outfit%20with%20refined%20traditional%20hair%20style%2C%20warm%20neutral%20studio%20background%2C%20gentle%20expressive%20gaze%2C%20high%20fashion%20magazine%20lighting&width=500&height=625&seq=actor-01&orientation=portrait',
    region: '中国大陆',
    gender: '女',
    activeYears: ['2023-2025'],
    summary:
      '新生代实力派演员，凭借《长夜星河》中落魄郡主一角广受关注。表演细腻克制，擅长以眼神传递复杂情绪，被媒体称为"最会演隐忍的年轻演员"。',
    latestNews: [
      { title: '苏晚棠凭《长夜星河》再获关注，谈塑造"落魄郡主"的心路', date: '2025-10-10', newsId: 'n003' },
    ],
  },
  {
    id: 'a02',
    name: '陆祈年',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20handsome%20young%20Chinese%20actor%20in%20a%20dark%20blue%20turtleneck%2C%20calm%20and%20thoughtful%20expression%2C%20moody%20indigo%20studio%20background%2C%20soft%20cinematic%20lighting%2C%20magazine%20cover%20quality&width=500&height=625&seq=actor-02&orientation=portrait',
    region: '中国大陆',
    gender: '男',
    activeYears: ['2022-2025'],
    summary:
      '以《长夜星河》中寒门谋士陆祈年一角跻身一线。戏路宽，从古装权谋到现代都市均有稳定表现，被观众评价为"台词与眼神都在线"的演员。',
    latestNews: [
      { title: '《长夜星河》收官获口碑逆袭，权谋叙事为何再次打动观众', date: '2025-10-14', newsId: 'n001' },
    ],
  },
  {
    id: 'a03',
    name: '江澈',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20serious%20Chinese%20male%20actor%20with%20short%20hair%20and%20light%20stubble%20in%20a%20dark%20coat%2C%20cold%20blue%20grey%20studio%20background%2C%20dramatic%20moody%20lighting%2C%20magazine%20cover%20quality&width=500&height=625&seq=actor-03&orientation=portrait',
    region: '中国大陆',
    gender: '男',
    activeYears: ['2020-2025'],
    summary:
      '长期深耕刑侦、悬疑类型剧，因《雾城谜案》中刑警队长一角成为"悬疑剧定海神针"。为贴近角色坚持实景拍摄与体能训练，被剧组称为"最拼的演员"。',
    latestNews: [
      { title: '《雾城谜案》双线叙事引热议，编剧回应结局争议', date: '2025-10-08', newsId: 'n004' },
    ],
  },
  {
    id: 'a04',
    name: '孟星禾',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20confident%20Chinese%20actress%20with%20a%20short%20bob%20wearing%20a%20tailored%20beige%20blazer%2C%20bright%20studio%20lighting%2C%20clean%20warm%20neutral%20background%2C%20modern%20professional%20magazine%20style&width=500&height=625&seq=actor-04&orientation=portrait',
    region: '中国大陆',
    gender: '女',
    activeYears: ['2019-2025'],
    summary:
      '都市剧代表人物之一，《逆光而行》中塑造的职场女性形象引发广泛共鸣。她偏爱"不完美"的角色，认为真实比讨喜更重要。',
    latestNews: [
      { title: '行业观察：国产都市剧正在"去爽感化"？', date: '2025-10-05', newsId: 'n005' },
    ],
  },
  {
    id: 'a05',
    name: 'Emma Shaw',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20determined%20young%20American%20actress%20with%20short%20brown%20hair%20in%20a%20grey%20blazer%2C%20cool%20neutral%20studio%20background%2C%20confident%20expression%2C%20prestige%20magazine%20lighting&width=500&height=625&seq=actor-05&orientation=portrait',
    region: '美国',
    gender: '女',
    activeYears: ['2018-2025'],
    summary:
      '毕业于知名戏剧学院，以《沉默的证词》中公设辩护人一角获得广泛认可。表演风格内敛而有力，擅长处理高强度的法庭与心理戏份。',
    latestNews: [
      { title: 'Emma Shaw 谈《沉默的证词》：沉默本身就是一种台词', date: '2025-09-30', newsId: 'n007' },
    ],
  },
  {
    id: 'a06',
    name: 'Nora Bennett',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20intelligent%20American%20actress%20with%20sleek%20short%20hair%20in%20a%20dark%20turtleneck%2C%20cool%20cobalt%20blue%20studio%20background%2C%20focused%20scientific%20gaze%2C%20cinematic%20lighting&width=500&height=625&seq=actor-06&orientation=portrait',
    region: '美国',
    gender: '女',
    activeYears: ['2017-2025'],
    summary:
      '科幻题材的常客，在《量子边界》中饰演物理学家诺拉。为角色自学基础物理概念，被导演评价为"把科学家的思维方式演了出来"。',
    latestNews: [
      { title: '科幻剧《量子边界》上线：硬核设定下的情感内核', date: '2025-09-22', newsId: 'n009' },
    ],
  },
  {
    id: 'a07',
    name: '温以宁',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20warm%20young%20Chinese%20actress%20with%20shoulder%20length%20hair%20and%20soft%20smile%20in%20a%20cream%20knit%20sweater%2C%20soft%20orange%20warm%20studio%20lighting%2C%20gentle%20healing%20mood%2C%20magazine%20style&width=500&height=625&seq=actor-07&orientation=portrait',
    region: '中国大陆',
    gender: '女',
    activeYears: ['2021-2025'],
    summary:
      '以治愈系作品见长，《春日便利店》中夜班店员温以宁一角被称为"最想被她治愈的角色"。她本人也长期关注心理健康公益项目。',
    latestNews: [
      { title: '《春日便利店》迎收官：治愈系剧集为何总能长留人心', date: '2025-09-27', newsId: 'n008' },
    ],
  },
  {
    id: 'a08',
    name: '萧无咎',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20charismatic%20Chinese%20actor%20in%20ornate%20Tang%20dynasty%20costume%20with%20gold%20embroidery%2C%20warm%20golden%20crimson%20studio%20background%2C%20regal%20expression%2C%20epic%20period%20drama%20poster%20lighting&width=500&height=625&seq=actor-08&orientation=portrait',
    region: '中国大陆',
    gender: '男',
    activeYears: ['2016-2025'],
    summary:
      '古装群像剧《长安十二时》主演，以极具辨识度的古装扮相和扎实的武戏功底著称。他坚持亲自完成大部分动作镜头，鲜少使用替身。',
    latestNews: [
      { title: '《长安十二时》持续出圈，群像塑造的"方法论"', date: '2025-10-03', newsId: 'n006' },
    ],
  },
  {
    id: 'a09',
    name: '韩霜',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20resilient%20Chinese%20actress%20in%20a%20dark%20wool%20coat%20with%20calm%20determined%20eyes%2C%20cold%20winter%20grey%20studio%20background%2C%20restrained%20emotion%2C%20prestige%20drama%20lighting&width=500&height=625&seq=actor-09&orientation=portrait',
    region: '中国大陆',
    gender: '女',
    activeYears: ['2014-2025'],
    summary:
      '年代剧《雪落无声》主演，被誉为"最能把沉默演出重量"的演员。多年来专注现实主义题材，表演沉稳而有层次。',
    latestNews: [
      { title: '年代剧《雪落无声》口碑走高：小城故事里的大时代', date: '2025-09-18', newsId: 'n010' },
    ],
  },
  {
    id: 'a10',
    name: '沈星回',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20dreamy%20young%20Chinese%20actor%20with%20soft%20features%20and%20dark%20hair%20in%20a%20navy%20sweater%2C%20deep%20indigo%20starry%20studio%20background%2C%20romantic%20youthful%20mood%2C%20magazine%20style&width=500&height=625&seq=actor-10&orientation=portrait',
    region: '中国大陆',
    gender: '男',
    activeYears: ['2022-2025'],
    summary:
      '新生代人气演员，《星辰之下》中饰演能预见未来的天文社少年。以清新自然的表演风格受到年轻观众喜爱。',
    latestNews: [
      { title: '本季度新剧排播一览：多部悬疑题材集中上线', date: '2025-10-12', newsId: 'n002' },
    ],
  },
  {
    id: 'a11',
    name: '林昭昭',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20soft%20young%20Chinese%20actress%20with%20natural%20makeup%20and%20loose%20wavy%20hair%20wearing%20a%20linen%20shirt%2C%20pale%20cream%20studio%20background%2C%20gentle%20literary%20mood%2C%20film%20photography%20style&width=500&height=625&seq=actor-11&orientation=portrait',
    region: '中国大陆',
    gender: '女',
    activeYears: ['2020-2025'],
    summary:
      '文艺片与治愈剧双栖演员，《海边的旧信》中细腻的表演被影评人称为"有呼吸感的演出"。业余爱好是写作与旧书收藏。',
    latestNews: [
      { title: '行业观察：国产都市剧正在"去爽感化"？', date: '2025-10-05', newsId: 'n005' },
    ],
  },
  {
    id: 'a12',
    name: '이서연',
    photo: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20elegant%20Korean%20actress%20with%20long%20wavy%20hair%20in%20a%20soft%20purple%20dress%2C%20moody%20deep%20blue%20studio%20background%2C%20calm%20sophisticated%20expression%2C%20magazine%20cover%20lighting&width=500&height=625&seq=actor-12&orientation=portrait',
    region: '韩国',
    gender: '女',
    activeYears: ['2019-2025'],
    summary:
      '韩剧《首尔凌晨三点》女主角，饰演深夜电台主持人。以富有磁性的声线与细腻的情感表达著称，是韩国近年备受关注的新生代女演员。',
    latestNews: [
      { title: '本季度新剧排播一览：多部悬疑题材集中上线', date: '2025-10-12', newsId: 'n002' },
    ],
  },
];

export const actorRegions: string[] = ['全部地区', '中国大陆', '韩国', '美国'];
export const actorGenders: string[] = ['全部', '男', '女'];
export const actorPeriods: string[] = ['全部', '近三年活跃', '五年以上', '十年以上'];